import {
  ITINERARYDETAILS_FETCH_SUCCESS,
  ITINERARYDETAILS_FETCH_INVOKED,
  ITINERARYDETAILS_FETCH_FAILED,
} from "src/redux/actions/itineraryDetails";
import { CarRentalI } from "src/types/CarRental";
import { FlightSegment } from "src/types/Flight";
import { HotelCardI } from "src/types/Hotel";
import { Passenger } from "src/types/Passenger";
import { RailSegmentI } from "src/types/RailSegment";

export type ItineraryI = {
  elapsedTime?: { outbound: number; return: number };
  id: string;
  debtorName?: string;
  flights?: { outbound: FlightSegment[]; return: FlightSegment[] };
  carRentals?: CarRentalI[];
  hotels?: HotelCardI[];
  passengers: Passenger[];
  rail: RailSegmentI[];
  prices: {
    total: {
      amount: number;
      currency: string;
    };
  };
};

type ItinState = {
  loading: boolean;
  error?: Error;
  data?: ItineraryI[];
  showDebtorName?: boolean;
};

export const initialState: {
  ids: {
    [key: string]: ItinState;
  };
} = { ids: {} };

export type ItineraryDetailsI = typeof initialState;

type ItineraryDetailsFetchInvokedI = {
  type: typeof ITINERARYDETAILS_FETCH_INVOKED;
  id: string;
};

type ItineraryDetailsFetchSuccessI = {
  type: typeof ITINERARYDETAILS_FETCH_SUCCESS;
  id: string;
  payload: ItineraryI[];
  showDebtorName: boolean;
};

type ItineraryDetailsFetchFailedI = {
  type: typeof ITINERARYDETAILS_FETCH_FAILED;
  id: string;
  error: Error;
};

export type IntineraryDetailsAction =
  | ItineraryDetailsFetchInvokedI
  | ItineraryDetailsFetchSuccessI
  | ItineraryDetailsFetchFailedI;

const itineraryDetails = (
  state = initialState,
  action: IntineraryDetailsAction,
): ItineraryDetailsI => {
  switch (action.type) {
    case ITINERARYDETAILS_FETCH_INVOKED:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            loading: true,
          },
        },
      };
    case ITINERARYDETAILS_FETCH_SUCCESS:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            loading: false,
            data: action.payload,
            showDebtorName: action.showDebtorName,
          },
        },
      };
    case ITINERARYDETAILS_FETCH_FAILED:
      return {
        ...state,
        ids: {
          ...state.ids,
          [action.id]: {
            loading: false,
            error: action.error,
          },
        },
      };
    default:
      return state;
  }
};

export default itineraryDetails;
